import { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { theme } from '../../../theme/theme';
import timezoneSpecs from '../../../data/timezones';

const OperatingTimezoneSelect = (props) => {

  const [timezone, setOperatingTimezone] = useState(props.timezone);

  const handleOperatingTimezoneChanged = (event) => {
    setOperatingTimezone(event.target.value);
    if (props.onChange) {
      props.onChange({"timezone": event.target.value});
    } else {
      console.error("OperatingTimezone changed handler not defined");
    }
  };

  useEffect(() => {
    setOperatingTimezone(props.timezone);
  }, [props.timezone]);

  return (
    <TextField 
      select
      onChange={handleOperatingTimezoneChanged}
      disabled={props.disabled}
      value={timezone ?? ''}
      fullWidth
      sx={{ 
        "& .MuiOutlinedInput-root":{"& > fieldset": {borderColor: theme.palette.secondary.main}},
        "& .MuiOutlinedInput-input":{color: 'white'},
        "& .MuiOutlinedInput-input.Mui-disabled":{WebkitTextFillColor: 'white'},
        "& .MuiSelect-icon":{color: 'white'},
        "& .Mui-disabled":{"& > .MuiSelect-icon": {color: 'inherit'}},
        textAlignLast: 'end'
      }}
    >
      {timezoneSpecs?.sort((t1, t2) => {
        return t1 < t2 ? -1 : 1;
      }).map(tz => {
        return <MenuItem key={tz} value={tz}>{tz}</MenuItem>;
      })}
    </TextField>
  );
};

export default OperatingTimezoneSelect;